
import { getIdentity } from '@/utils/extendFormVaildate'

const legalIdType = {
  1: '身份证',
  2: '中国护照',
  3: '港澳居民往来内地通行证',
  4: '台胞证',
  7: '外国护照',
}

const config = function () {
  return {
    accountList: [
      {
        el: 'select',
        itemConfig: {
          label: '清分渠道',
          prop: 'channelType',
        },
        elConfig: {
          disabled: true,
          options: {
            label: 'bankName',
            value: 'bankCode',
            list: [],
          },
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '公司主体全称',
          prop: 'merchantName',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '100',
          disabled: false,
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '统一社会信用代码证号',
          prop: 'licenceNo',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '18',
          disabled: false,
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '法人姓名',
          prop: 'legalContactName',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '100',
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '法人手机号',
          prop: 'legalContactMobile',
        },
        elConfig: {
          placeholder: '请输入',
        },
        directives: [{ name: 'number', arg: 'phone' }],
      },
      {
        el: 'select',
        itemConfig: {
          label: '法人证件类型',
          prop: 'legalIdType',
        },
        elConfig: {
          placeholder: '请选择',
          options: {
            label: 'label',
            value: 'value',
            list: this.dictParseList(legalIdType),
          },
        },
      },
      {
        el: 'input',
        itemConfig: {
          label: '法人证件号码',
          prop: 'legalIdNo',
        },
        elConfig: {
          placeholder: '请输入',
          maxlength: '18',
        },
      },
    ],
    accountRules: {
      merchantName: [
        {
          required: true,
          message: '公司主体全称不能为空',
          trigger: 'change',
        },
      ],
      licenceNo: [
        {
          required: true,
          message: '请输入正确的统一社会信用代码证号',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value === '') callback('请输入统一社会信用代码证号')
            getIdentity(rule, value, callback)
          },
        },
      ],
      legalContactName: [
        {
          required: true,
          message: '法人姓名不能为空',
          trigger: 'change',
        },
      ],
      legalContactMobile: [
        {
          required: true,
          message: '请输入正确的手机号',
          trigger: 'change',
        },
      ],
      legalIdType: [
        {
          required: true,
          message: '请选择法人证件类型',
          trigger: 'change',
        },
      ],
      legalIdNo: [
        {
          required: true,
          message: '请输入正确的证件号码',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value === '') callback('法人证件号码不能为空')
            getIdentity(rule, value, callback)
          },
        },
      ],
    },
  }
}

export default config
